import * as React from 'react';
import { Variant } from '../types.js';

const useNoTimeSlotsVariant = (timeSlots, nextAvailableDate, selectedDate, closedDates, skip, hasActiveTimeFilter)=>{
    return React.useMemo(()=>{
        const storeClosed = Boolean(closedDates === null || closedDates === void 0 ? void 0 : closedDates.find((item)=>new Date(item).toDateString() === (selectedDate && new Date(selectedDate).toDateString())
        ));
        if (skip) {
            return Variant.none;
        }
        if (!selectedDate) {
            return Variant.none;
        }
        if (!timeSlots.called || timeSlots.loading) {
            return Variant.none;
        }
        if (timeSlots.error) {
            return Variant.error;
        }
        if (storeClosed && nextAvailableDate) {
            return Variant.closedDate;
        }
        if (storeClosed && !nextAvailableDate) {
            return Variant.closedWeek;
        }
        if (hasActiveTimeFilter && !timeSlots.filtered.included.length && nextAvailableDate) {
            return Variant.time;
        }
        if (!timeSlots.filtered.included.length && nextAvailableDate) {
            return Variant.date;
        }
        if (!timeSlots.filtered.included.length && !nextAvailableDate) {
            return Variant.week;
        }
        return Variant.none;
    }, [
        selectedDate,
        timeSlots,
        nextAvailableDate,
        closedDates,
        skip,
        hasActiveTimeFilter
    ]);
};

export { useNoTimeSlotsVariant as default, useNoTimeSlotsVariant };
//# sourceMappingURL=use-no-timeslot-variant.js.map
